var pa1 = "/static/0a26d22619c2c907.png";

export { pa1 as default };
//# sourceMappingURL=pa_1.png.js.map
